(function () {
  if (window.__bbCardActionsInit) return;
  window.__bbCardActionsInit = true;

  var COMPARE_KEY = 'bb_compare_handles';
  var WISHLIST_KEY = 'bb_wishlist_handles';
  var COMPARE_MAX = 4;

  function readList(key) {
    try {
      var raw = localStorage.getItem(key);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(key, list) {
    localStorage.setItem(key, JSON.stringify(list));
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return cents;
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function syncButtons() {
    var compare = readList(COMPARE_KEY);
    var wishlist = readList(WISHLIST_KEY);

    // Sync compare buttons
    document.querySelectorAll('[data-compare-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-compare-handle');
      var isActive = compare.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    // Sync wishlist buttons
    document.querySelectorAll('[data-wishlist-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      var isActive = wishlist.indexOf(handle) !== -1;

      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

      var label = btn.querySelector('.wishlist-label');
      if (label) {
        label.textContent = isActive ? 'Saved' : 'Wishlist';
      }

      // Direct SVG & style updates to guarantee red heart in all browsers
      var svg = btn.querySelector('svg');
      var paths = btn.querySelectorAll('svg path');

      if (isActive) {
        btn.style.setProperty('color', '#ef4444', 'important');
        btn.style.setProperty('background-color', '#fef2f2', 'important');
        btn.style.setProperty('border-color', '#fca5a5', 'important');
        if (svg) {
          svg.style.setProperty('fill', '#ef4444', 'important');
          svg.style.setProperty('stroke', '#ef4444', 'important');
        }
        paths.forEach(function (p) {
          p.setAttribute('fill', '#ef4444');
          p.setAttribute('stroke', '#ef4444');
          p.style.setProperty('fill', '#ef4444', 'important');
          p.style.setProperty('stroke', '#ef4444', 'important');
        });
      } else {
        btn.style.removeProperty('color');
        btn.style.removeProperty('background-color');
        btn.style.removeProperty('border-color');
        if (svg) {
          svg.style.removeProperty('fill');
          svg.style.removeProperty('stroke');
        }
        paths.forEach(function (p) {
          p.setAttribute('fill', 'none');
          p.setAttribute('stroke', 'currentColor');
          p.style.removeProperty('fill');
          p.style.removeProperty('stroke');
        });
      }
    });

    // Sync count bubbles
    var count = wishlist.length;
    document.querySelectorAll('.wishlist-count').forEach(function (el) {
      el.textContent = count;
    });

    var countBadge = document.getElementById('WishlistDrawerCount');
    if (countBadge) {
      countBadge.textContent = count;
    }

    var bubble = document.querySelector('#wishlist-icon-bubble .wishlist-count-bubble');
    if (bubble) {
      bubble.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function toggle(key, handle, max) {
    if (!handle) return false;
    var list = readList(key);
    var idx = list.indexOf(handle);
    var added = false;
    if (idx !== -1) {
      list.splice(idx, 1);
    } else {
      if (max && list.length >= max) {
        list.shift();
      }
      list.push(handle);
      added = true;
    }
    writeList(key, list);
    syncButtons();
    return added;
  }

  function openWishlistDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    renderWishlistDrawer();
  }

  function closeWishlistDrawer() {
    var drawer = document.getElementById('WishlistDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  function renderWishlistDrawer() {
    var wishlist = readList(WISHLIST_KEY);
    var emptyEl = document.getElementById('WishlistDrawerEmpty');
    var itemsEl = document.getElementById('WishlistDrawerItems');
    var footerEl = document.getElementById('WishlistDrawerFooter');

    if (!itemsEl) return;

    if (wishlist.length === 0) {
      if (emptyEl) emptyEl.style.display = 'block';
      itemsEl.style.display = 'none';
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';
    itemsEl.style.display = 'block';
    if (footerEl) footerEl.style.display = 'block';

    itemsEl.innerHTML = '<div class="wishlist-drawer__loading"><div class="loading-spinner"></div><p>Loading your saved items...</p></div>';

    var fetches = wishlist.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(fetches).then(function (products) {
      var validProducts = products.filter(Boolean);

      if (validProducts.length === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        itemsEl.style.display = 'none';
        itemsEl.innerHTML = '';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      var html = validProducts.map(function (prod) {
        var imgUrl = prod.featured_image || (prod.images && prod.images[0]) || '';
        var priceFormatted = formatMoney(prod.price);
        var variantId = prod.variants && prod.variants[0] ? prod.variants[0].id : '';
        var available = prod.available;

        return (
          '<div class="wishlist-drawer__item" data-item-handle="' + prod.handle + '">' +
            '<a href="' + prod.url + '" class="wishlist-drawer__item-image-wrap">' +
              '<img src="' + imgUrl + '" alt="' + prod.title + '" loading="lazy" width="80" height="80">' +
            '</a>' +
            '<div class="wishlist-drawer__item-info">' +
              '<a href="' + prod.url + '" class="wishlist-drawer__item-title">' + prod.title + '</a>' +
              '<div class="wishlist-drawer__item-price">' + priceFormatted + '</div>' +
              '<div class="wishlist-drawer__item-actions">' +
                (available ?
                  '<button type="button" class="wishlist-drawer__add-to-cart-btn button button--primary" data-add-variant="' + variantId + '">Add to Cart</button>' :
                  '<button type="button" class="wishlist-drawer__add-to-cart-btn button button--secondary" disabled>Sold Out</button>') +
                '<button type="button" class="wishlist-drawer__remove-btn" data-remove-wishlist="' + prod.handle + '" aria-label="Remove item">' +
                  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                    '<line x1="18" y1="6" x2="6" y2="18"></line>' +
                    '<line x1="6" y1="6" x2="18" y2="18"></line>' +
                  '</svg>' +
                  '<span>Remove</span>' +
                '</button>' +
              '</div>' +
            '</div>' +
          '</div>'
        );
      }).join('');

      itemsEl.innerHTML = html;
    });
  }

  // Expose Global Methods
  window.toggleWishlist = function (handleOrElement) {
    var handle = typeof handleOrElement === 'string' ? handleOrElement : (handleOrElement && handleOrElement.getAttribute('data-wishlist-handle'));
    if (!handle) return;
    var added = toggle(WISHLIST_KEY, handle);
    if (added) {
      openWishlistDrawer();
    }
  };

  window.openWishlistDrawer = openWishlistDrawer;
  window.closeWishlistDrawer = closeWishlistDrawer;
  window.syncWishlistButtons = syncButtons;

  // Global Event Listeners
  document.addEventListener('click', function (event) {
    // Compare toggle
    var compareBtn = event.target.closest('[data-compare-handle]');
    if (compareBtn) {
      event.preventDefault();
      toggle(COMPARE_KEY, compareBtn.getAttribute('data-compare-handle'), COMPARE_MAX);
      return;
    }

    // Wishlist toggle
    var wishBtn = event.target.closest('[data-wishlist-handle]');
    if (wishBtn) {
      event.preventDefault();
      event.stopPropagation();
      var handle = wishBtn.getAttribute('data-wishlist-handle');
      var added = toggle(WISHLIST_KEY, handle);
      if (added) {
        openWishlistDrawer();
      }
      return;
    }

    // Open wishlist drawer trigger
    var openDrawerBtn = event.target.closest('[data-open-wishlist-drawer]');
    if (openDrawerBtn) {
      event.preventDefault();
      openWishlistDrawer();
      return;
    }

    // Close wishlist drawer trigger
    var closeDrawerBtn = event.target.closest('[data-close-wishlist-drawer]');
    if (closeDrawerBtn) {
      event.preventDefault();
      closeWishlistDrawer();
      return;
    }

    // Remove item from drawer
    var removeBtn = event.target.closest('[data-remove-wishlist]');
    if (removeBtn) {
      event.preventDefault();
      var itemHandle = removeBtn.getAttribute('data-remove-wishlist');
      toggle(WISHLIST_KEY, itemHandle);
      renderWishlistDrawer();
      return;
    }

    // Add to cart from wishlist drawer
    var addToCartBtn = event.target.closest('[data-add-variant]');
    if (addToCartBtn && !addToCartBtn.disabled) {
      event.preventDefault();
      var vId = addToCartBtn.getAttribute('data-add-variant');
      if (!vId) return;

      var origText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: vId, quantity: 1 }] })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        addToCartBtn.textContent = 'Added!';
        setTimeout(function () {
          addToCartBtn.textContent = origText;
          addToCartBtn.disabled = false;
        }, 1500);

        if (document.querySelector('cart-drawer')) {
          fetch(window.location.href).then(function (r) { return r.text(); }).then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var drawer = doc.querySelector('cart-drawer');
            if (drawer) {
              var currentDrawer = document.querySelector('cart-drawer');
              if (currentDrawer) currentDrawer.innerHTML = drawer.innerHTML;
            }
          });
        }
      })
      .catch(function () {
        addToCartBtn.textContent = 'Error';
        setTimeout(function () {
          addToCartBtn.textContent = origText;
          addToCartBtn.disabled = false;
        }, 1500);
      });
      return;
    }

    // Clear all wishlist items
    var clearBtn = event.target.closest('#WishlistClearAll');
    if (clearBtn) {
      event.preventDefault();
      writeList(WISHLIST_KEY, []);
      syncButtons();
      renderWishlistDrawer();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncButtons);
  } else {
    syncButtons();
  }

  document.addEventListener('shopify:section:load', syncButtons);
  window.addEventListener('load', syncButtons);
})();
